import React from "react";
import { Typography, Box, Grid2} from "@mui/material";
import MyWorkKPI from "./MyWorkKPI";

const MyWork = () => {
    return (
        <>
            <Grid2 container spacing={2} sx={{ mt: '20px' }}>
                <Box sx={{ width: '100%', display: 'flex', justifyContent: 'space-between' }}>
                    <Typography variant="h5" sx={{ fontSize: '24px', fontWeight: '500', color: '#252525', mb: 2, lineHeight: "32px", letterSpacing: '-0.4px' }}>
                        My Work
                    </Typography>
                </Box>
            </Grid2>
            <Grid2 container spacing={2}>
                <Grid2 size={{ xs: 12, md: 12 }}>
                    <MyWorkKPI />
                </Grid2>
            </Grid2>
        </>
    );
};

export default MyWork;